
import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { IAPPSTATE } from '@/store/state.d';
import menuTrigger from './components/trigger.vue';
import menuAvatar from './components/avatar.vue';
import menuFull from './components/fullscreen.vue';

@Component({
  components: {
    menuTrigger,
    menuAvatar,
    menuFull,
  },
})
export default class THeader extends Vue {
  @State app!: IAPPSTATE;
}
